import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { getOrgLocations, setLocationCurrentPage } from '~/apps/shared/actions/locations';
import LocationListTable from '../../components/locations/LocationListTable';
import { defaultTablePageSize } from '~/common/components/consts';
import { navigate } from '~/router';
import { Features, UserRole } from '../../consts';

class OrgLocationList extends React.Component<any, any> {
  componentDidUpdate = (prevProps) => {
    if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        // TODO: Paging should be controlled by the component
        this.onFetchData({ page: 0, pageSize: defaultTablePageSize }, null);
      }
    }
  };

  onFetchData = (state, instance) => {
    const { orgId, filter, dispatch } = this.props;
    dispatch(getOrgLocations(orgId, filter, state.page * state.pageSize));
  };

  onClick = (model) => {
    this.props.onClick(model.id);
  };

  handleGoToProducts = (location) => {
    navigate("pos.admin.products", { locationId: location.id });
  };

  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setLocationCurrentPage(page));
  };

  render() {
    const { locations, editLabel, features, role } = this.props;
    const isEnableProductsPage = features?.includes(Features.ENABLE_PRODUCTS_PAGE);
    const isProductsEnabled = isEnableProductsPage && (role === UserRole.AGENT || role === UserRole.WAREHOUSE_MANAGER);

    return (
      <LocationListTable
        manual={true}
        loading={locations.ui.loading}
        page={locations.ui.currentPage}
        data={locations.ui.currentList.map((u) => locations.entities[u])}
        onFetchData={this.onFetchData}
        onClick={this.onClick}
        onPageChange={this.onPageChange}
        editLabel={editLabel || "Edit"}
        isProductsEnabled={isProductsEnabled}
        onGoToProducts={this.handleGoToProducts}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    organizations: state.shared.organizations,
    locations: state.shared.locations,
    role: state.shared.auth.currentUser.role,
    features: state.shared.information.entities.features,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgLocationList);
